var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgBlueDownArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.957485 0.982144C1.24349 0.682521 1.71823 0.67148 2.01786 0.957485L6.82738 5.54839C6.92399 5.64061 7.07601 5.64061 7.17262 5.54839L11.9821 0.957485C12.2818 0.67148 12.7565 0.682521 13.0425 0.982144C13.3285 1.28177 13.3175 1.75651 13.0179 2.04252L8.20833 6.63343C7.53209 7.27893 6.46791 7.27893 5.79167 6.63343L0.982144 2.04252C0.682521 1.75651 0.67148 1.28177 0.957485 0.982144Z",
    fill: "#3D82F1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueDownArrow);
export default __webpack_public_path__ + "static/media/BlueDownArrow.871052e7902bcc996055fe40c99edb99.svg";
export { ForwardRef as ReactComponent };